/**
 * Shown only when a submission fails for a non-validation reason. Field-level
 * errors render inline under their inputs (LeadForm.tsx pushes the server's
 * validationErrors into the machine), so a summary here would duplicate them.
 */
function LeadFormSubmissionError() {
  return (
    <div
      className="mt-2 rounded border border-red-200 bg-red-50 p-3 text-red-700 text-sm"
      role="alert"
    >
      <p>Something went wrong. Please try again.</p>
    </div>
  );
}

export { LeadFormSubmissionError };
